import { CSSObject } from '@chakra-ui/react';

export const GridRaceItems: CSSObject = {
  columnGap: 'unset',
  mx: 'unset',

  gridAutoFlow: {
    base: 'row',
    md: 'column',
  },

  gap: {
    base: '3',
    lg: '4',
  },
};

export const BoxColumn: CSSObject = {
  display: 'flex',
  flexDir: 'column',
  gap: '2',
  mb: 0,
};

export const TextRaceNumber: CSSObject = {
  flex: 0,
  py: '1',
  fontWeight: 'bold',
  textAlign: 'center',
  minWidth: '6',
  display: 'inline-block',
  fontSize: '2xs',
  h: '4',
  bg: 'gamma.400',
  borderRadius: 'sm',
  color: 'blackAlpha.700',
  ml: '0.5',
  lineHeight: '0.7',
  boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.25)',
};

export const LinkRaceContainer: CSSObject = {
  bgGradient: 'linear(to-b, alpha.300, alpha.400)',
  color: 'white',
  borderRadius: 'md',
  boxShadow:
    '0px 4px 10px 0px rgba(0, 0, 0, 0.30), 0px 0px 0px 1px rgba(255, 255, 255, 0.12) inset',
  mb: '0',
  transition: 'all ease 0.5s',
  p: '3',
  _hover: {
    transition: 'all ease 0.5s',
    bgGradient: 'linear(to-b, alpha.400, alpha.400)',
  },
  '.chakra-badge': {
    boxShadow:
      '0px 2px 4px 0px rgba(0, 0, 0, 0.25), 0px 1px 1px 0px rgba(0, 0, 0, 0.15)',
  },
  '[class*="CountdownFlex"]': {
    bg: 'unset',
  },
};

export const TextRaceType: CSSObject = {
  fontFamily: 'heading',
  color: 'white',
  textShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
  fontSize: 'md',
  textTransform: 'uppercase',
  fontWeight: 'normal',
  mb: 0,
};

export const TextRace: CSSObject = {
  fontFamily: 'heading',
  color: 'white',
  fontWeight: 'normal',
  fontSize: 'sm',
  textShadow: '0px 3px 4px rgba(0, 0, 0, 0.25)',
  textTransform: 'uppercase',
};

export const Icon: CSSObject = {
  boxSize: '4',
  color: 'beta.400',
  filter: 'drop-shadow(0px 3px 4px rgba(0, 0, 0, 0.25))',
};
